module.exports = __webpack_public_path__ + "static/media/foto 4 francisco ismodes en moquegua.71e13bac.jpg";